var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _class3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { reads } from '@ember/object/computed';
import { computed, set } from '@ember/object';
import { isPresent, isNone } from '@ember/utils';
import { attr, hasMany } from '@ember-data/model';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
function flattenAllProductSets(productSet, productSets = new Set()) {
  if (productSets.has(productSet)) {
    return []; // avoid duplicate work and infinite cycles
  }
  productSets.add(productSet);
  productSet.productSetsAll.forEach(innerProductSet => {
    flattenAllProductSets(innerProductSet, productSets);
  });
  productSet.productSetsAny.forEach(innerProductSet => {
    flattenAllProductSets(innerProductSet, productSets);
  });
  return [...productSets];
}

// Represents a rule for matching a set of products for a cart when
// applying an automatic Discount
let _class = (_dec = attr('string'), _dec2 = hasMany('category'), _dec3 = hasMany('item'), _dec4 = hasMany('item-variation'), _dec5 = hasMany('surcharge'), _dec6 = hasMany('category'), _dec7 = hasMany('item'), _dec8 = hasMany('item-variation'), _dec9 = hasMany('surcharge'), _dec10 = hasMany('product-set', {
  inverse: null
}), _dec11 = hasMany('product-set', {
  inverse: null
}), _dec12 = attr('boolean', {
  allowNull: true
}), _dec13 = attr('array'), _dec14 = computed('_categories', 'allowedCategories.[]', 'requiredCategories.[]'), _dec15 = computed('_itemsOverride', 'allowedItems.[]', 'requiredItems.[]'), _dec16 = computed('_itemVariations', 'allowedItemVariations.[]', 'requiredItemVariations.[]'), _dec17 = computed('requiredSurcharges.[]', 'allowedSurcharges.[]', function () {
  if (isPresent(this.requiredSurcharges)) {
    return this.requiredSurcharges;
  } else {
    return this.allowedSurcharges;
  }
}), _dec18 = reads('version'), _dec19 = attr('number'), _dec20 = attr('number'), _dec21 = attr('number'), _dec22 = attr('boolean', {
  allowNull: true
}), _dec23 = computed('hasDirtyFields', 'productSetsAll', 'productSetsAny', function () {
  return this.hasDirtyFields || this.productSetsAll.any(({
    isDirty
  }) => isDirty) || this.productSetsAny.any(({
    isDirty
  }) => isDirty);
}), _dec24 = computed('categories.[]', 'itemVariations.[]', 'items.[]', 'surcharges.[]', 'matchAllProducts', function () {
  return this.matchAllProducts || isPresent(this.categories) || isPresent(this.items) || isPresent(this.itemVariations) || isPresent(this.surcharges);
}), _class2 = (_class3 = class _class2 extends ItemsV3Base {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    // The products that a product set matches can be categories, items, or item variations
    // These products can either be 'required' or 'allowed' and these are modeled on the server
    // side as the six different product properties below with appropriately prefixed names
    // classifying them as either 'required' product properties or 'allowed' product properties
    //
    // A product set can only have 'required' type product properties or 'allowed' type products
    // This constraint is enforced on the server side.
    //
    // Currently the Dashboard only uses the 'allowed' type products for the Automatic Discounts feature
    // The 'required' type products will be used for the upcoming Volume Discount and bundling features
    // These three attributes are set when a product set must
    // consist of all specified products
    _initializerDefineProperty(this, "requiredCategories", _descriptor2, this);
    _initializerDefineProperty(this, "requiredItems", _descriptor3, this);
    _initializerDefineProperty(this, "requiredItemVariations", _descriptor4, this);
    _initializerDefineProperty(this, "requiredSurcharges", _descriptor5, this);
    // These three attributes are set when a product set may
    // consist of any specified products
    _initializerDefineProperty(this, "allowedCategories", _descriptor6, this);
    _initializerDefineProperty(this, "allowedItems", _descriptor7, this);
    _initializerDefineProperty(this, "allowedItemVariations", _descriptor8, this);
    _initializerDefineProperty(this, "allowedSurcharges", _descriptor9, this);
    _initializerDefineProperty(this, "productSetsAll", _descriptor10, this);
    _initializerDefineProperty(this, "productSetsAny", _descriptor11, this);
    _initializerDefineProperty(this, "matchCustomAmounts", _descriptor12, this);
    // List of line item types this product set will match with
    _initializerDefineProperty(this, "productLineItemTypes", _descriptor13, this);
    _initializerDefineProperty(this, "surcharges", _descriptor14, this);
    _initializerDefineProperty(this, "relationshipTrackerVersion", _descriptor15, this);
    // Set when there is an exact quantity for each product
    _initializerDefineProperty(this, "exactQuantity", _descriptor16, this);
    // Set when there is a minimum quantity for each product
    _initializerDefineProperty(this, "minQuantity", _descriptor17, this);
    // Used for range-based discounts
    _initializerDefineProperty(this, "maxQuantity", _descriptor18, this);
    _initializerDefineProperty(this, "matchAllProducts", _descriptor19, this);
    _initializerDefineProperty(this, "isDirty", _descriptor20, this);
    _initializerDefineProperty(this, "productsAreSelected", _descriptor21, this);
  }
  static catalogType() {
    return 'PRODUCT_SET';
  }
  // Convenience methods for accessing associated products
  get categories() {
    if (this._categories !== undefined) {
      return this._categories;
    }
    if (isPresent(this.requiredCategories)) {
      return this.requiredCategories;
    } else {
      return this.allowedCategories;
    }
  }
  set categories(value) {
    set(this, '_categories', value);
  }
  get items() {
    if (this._itemsOverride) {
      return this._itemsOverride;
    }
    if (isPresent(this.requiredItems)) {
      return this.requiredItems;
    } else {
      return this.allowedItems;
    }
  }
  set items(value) {
    set(this, '_itemsOverride', value);
  }
  get itemVariations() {
    if (this._itemVariations !== undefined) {
      return this._itemVariations;
    }
    if (isPresent(this.requiredItemVariations)) {
      return this.requiredItemVariations;
    } else {
      return this.allowedItemVariations;
    }
  }
  set itemVariations(value) {
    set(this, '_itemVariations', value);
  }
  // Use `hasMany` relationship metadata to read relationship ids
  // without requiring the PromiseManyArray to have been resolved
  ownCategoryIds() {
    const reqCategoryIds = this.hasMany('requiredCategories').ids();
    const allowedCategoryIds = this.hasMany('allowedCategories').ids();
    if (isPresent(reqCategoryIds)) {
      return reqCategoryIds;
    } else {
      return allowedCategoryIds;
    }
  }
  ownItemIds() {
    const reqItemIds = this.hasMany('requiredItems').ids();
    const allowedItemIds = this.hasMany('allowedItems').ids();
    if (isPresent(reqItemIds)) {
      return reqItemIds;
    } else {
      return allowedItemIds;
    }
  }
  ownItemVariationIds() {
    const reqItemVariationIds = this.hasMany('requiredItemVariations').ids();
    const allowedItemVariationIds = this.hasMany('allowedItemVariations').ids();
    if (isPresent(reqItemVariationIds)) {
      return reqItemVariationIds;
    } else {
      return allowedItemVariationIds;
    }
  }
  allCategoryIds() {
    const ids = flattenAllProductSets(this).flatMap(productSet => productSet.ownCategoryIds());
    return [...new Set(ids)];
  }
  allItemIds() {
    const ids = flattenAllProductSets(this).flatMap(productSet => productSet.ownItemIds());
    return [...new Set(ids)];
  }
  allItemVariationIds() {
    const ids = flattenAllProductSets(this).flatMap(productSet => productSet.ownItemVariationIds());
    return [...new Set(ids)];
  }
  allAllowedCategoryIds() {
    const ids = flattenAllProductSets(this).flatMap(productSet => productSet.hasMany('allowedCategories').ids());
    return [...new Set(ids)];
  }
  clear() {
    this.categories.clear();
    this.items.clear();
    this.itemVariations.clear();
    this.surcharges.clear();
    this.productSetsAll.clear();
    this.productSetsAny.clear();
  }
  revert() {
    this.rollbackAttributes();
  }

  /**
   * This method allows a user to pass in a list of catalog object ids selected in the Product Selector
   * and have this method automatically update allowedItems/allowedCategories/allowedItemVariations to match
   * the passed in list of ids.
   * @param {Object} tokensHash - Object containing arrays of object identifiers used to updated allowedCategories/Items/ItemVariations
   */
  updateAllowedModelsFromTokensHash(tokensHash) {
    function hydrateTokens(store, klass, tokens) {
      if (isPresent(tokens)) {
        return tokens.map(token => store.peekRecord(klass, token)).filter(Boolean);
      } else {
        return [];
      }
    }
    const allowedCategories = hydrateTokens(this.store, 'category', tokensHash.categories);

    // If a whole item is selected, don't select the variations as well.
    let allowedItems = hydrateTokens(this.store, 'item', tokensHash.items);
    const hydratedVariations = hydrateTokens(this.store, 'item-variation', tokensHash.itemVariations);
    const allowedItemVariations = hydratedVariations.map(variation => {
      if (allowedItems.includes(variation.get('item'))) {
        return null;
      } else {
        return variation;
      }
    }).compact();

    /**
     * If new categories are added, make sure items in those categories
     * are not present in the `allItems` array.
     */
    const newCategories = allowedCategories.filter(category => {
      return isNone(this.allowedCategories.findBy('id', category.id));
    });
    if (isPresent(newCategories)) {
      allowedItems = allowedItems.filter(item => {
        return isNone(newCategories.find(category => {
          return isPresent(category.items.findBy('id', item.id));
        }));
      });
    }
    this.watchRelationship('allowedCategories', () => {
      this.allowedCategories.setObjects(allowedCategories);
    });
    this.watchRelationship('allowedItems', () => {
      this.allowedItems.setObjects(allowedItems);
    });
    this.watchRelationship('allowedItemVariations', () => {
      this.allowedItemVariations.setObjects(allowedItemVariations);
    });
  }

  /**
   * This method allows the user to pass in a list of catalog object Ids that will be added
   * to the allowedItems/allowedCategories/allowedItemVariations
   * @param {Object} tokensHash - Object containing arrays of object identifiers used to updated allowedCategories/Items/ItemVariations
   */
  addAllowedModelsFromTokensHash(tokensHash) {
    const categories = this.categories.map(category => category.id);
    const items = this.items.map(item => item.id);
    const itemVariations = this.itemVariations.map(variation => variation.id);
    if (tokensHash.categories) {
      categories.push(...tokensHash.categories);
    }
    if (tokensHash.items) {
      items.push(...tokensHash.items);
    }
    if (tokensHash.itemVariations) {
      itemVariations.push(...tokensHash.itemVariations);
    }
    return this.updateAllowedModelsFromTokensHash({
      categories,
      items,
      itemVariations
    });
  }
  deleteModel() {
    this.deleted = true;
  }
}, _defineProperty(_class3, "currentUserAffectsEnabledUnitsAll", false), _defineProperty(_class3, "_modelNameForMigration", 'product-set'), _class3), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "requiredCategories", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "requiredItems", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "requiredItemVariations", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "requiredSurcharges", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "allowedCategories", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "allowedItems", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "allowedItemVariations", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "allowedSurcharges", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "productSetsAll", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "productSetsAny", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "matchCustomAmounts", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "productLineItemTypes", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "categories", [_dec14], Object.getOwnPropertyDescriptor(_class2.prototype, "categories"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "items", [_dec15], Object.getOwnPropertyDescriptor(_class2.prototype, "items"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "itemVariations", [_dec16], Object.getOwnPropertyDescriptor(_class2.prototype, "itemVariations"), _class2.prototype), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "surcharges", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "relationshipTrackerVersion", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "exactQuantity", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "minQuantity", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, "maxQuantity", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "matchAllProducts", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, "isDirty", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class2.prototype, "productsAreSelected", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { _class as default };